import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/cn";
import styles from "./wizardSteps.module.css";

interface WizardHeaderProps {
  step: number;
  totalSteps: number;
  onBack?: () => void;
}

export function WizardHeader({ step, totalSteps, onBack }: WizardHeaderProps) {
  return (
    <div className={styles.header}>
      <button
        type="button"
        onClick={onBack}
        disabled={!onBack}
        className={cn(styles.backCircle, !onBack && styles.backCircleHidden)}
        aria-label="Voltar"
      >
        <ChevronLeft size={18} strokeWidth={2.4} />
      </button>
      <div className={styles.progressTrack}>
        {Array.from({ length: totalSteps }).map((_, i) => (
          <span key={i} className={cn(styles.progressSegment, i <= step && styles.progressSegmentFilled)} />
        ))}
      </div>
    </div>
  );
}
